import { useLayoutEffect } from 'react';

/**
 * Detects when a click occurs outside the ref element and calls handler when so.
 * Handles both clicks and touches.
 * Likely not a big deal, but for optimal efficency handler should not change
 * on rerender (a useCallback handler achieves this).
 * TODO: split out touch events into seperate hook
 */
const useOnClickOutside = (
  ref: React.RefObject<Element> | React.RefObject<Element>[],
  handler: (event: MouseEvent | TouchEvent) => void | boolean,
) => {
  useLayoutEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (ref instanceof Array) {
        for (const r of ref) {
          if (
            r.current == null ||
            (event.target instanceof Node && r.current.contains(event.target))
          ) {
            return; // click inside
          }
        }
      } else if (
        ref.current == null ||
        (event.target instanceof Node && ref.current.contains(event.target))
      ) {
        return; // click inside
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
